module.exports = __webpack_public_path__ + "static/media/S1N13-4.ef12bb13.svg";